import React from "react";
import {
  Button,
  Icon,
  Tooltip,
  TooltipPopup,
  TooltipTrigger,
} from "@salestrak/ui";

import { HotkeyTooltipLabel } from "#app/components/keyboard-shortcuts/hotkey-tooltip-label";

import { useGlobalSearchActions } from "./global-search-context";
import { IS_MAC } from "#app/lib/platform";

// The ⌘ glyph only reads right on Mac; elsewhere spell the modifier out.
// `useCtrlKShortcut` fires on metaKey OR ctrlKey, so both labels are accurate.
export const SEARCH_SHORTCUT = IS_MAC ? ["⌘", "K"] : ["Ctrl", "K"];

/**
 * Tooltip body naming the search affordance beside its ⌘/Ctrl+K keycaps —
 * shared by the pane-header control and the module rail's collapsed-pane chip,
 * which is the same action in the rail's chrome.
 */
export function GlobalSearchTooltipLabel() {
  return <HotkeyTooltipLabel keys={SEARCH_SHORTCUT} label="Search" />;
}

/**
 * Global search as one icon control, sized for the sidebar-pane header's 28px
 * rung. It is the always-visible sibling of that header's create action — the
 * pair reads as "find" then "make", so search is pinned to the create
 * control's left and never joins the hover-revealed cluster.
 */
export function GlobalSearchButton(): React.ReactElement {
  const { openSearch } = useGlobalSearchActions();

  return (
    <Tooltip>
      <TooltipTrigger
        render={
          <Button
            aria-label="Search everything"
            onClick={() => openSearch("pane_header")}
            size="icon-sm"
            variant="ghost"
          >
            <Icon name="search" size="sm" />
          </Button>
        }
      />
      <TooltipPopup side="top">
        <GlobalSearchTooltipLabel />
      </TooltipPopup>
    </Tooltip>
  );
}
